import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import { allArticles, categories } from '@/mocks/data';

export default function Article() {
  const { slug } = useParams<{ slug: string }>();
  const article = allArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-[60vh] flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-3">文章未找到</h1>
            <Link to="/" className="text-sm text-primary-600 hover:text-primary-700 underline">
              返回首页
            </Link>
          </div>
        </main>
        <Footer newsletterSubmitAddr="https://readdy.ai/api/form/d9st0fllbrt1qcgaj9n0" />
      </>
    );
  }

  const category = categories.find((c) => c.slug === article.category);
  const relatedArticles = allArticles
    .filter((a) => a.category === article.category && a.slug !== article.slug)
    .slice(0, 3);

  const articleSchema = {
    headline: article.title,
    description: article.excerpt,
    datePublished: article.date,
    image: article.image,
    author: {
      '@type': 'Organization',
      name: '乳色吐息动漫粉丝站',
    },
    publisher: {
      '@type': 'Organization',
      name: '乳色吐息动漫粉丝站',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://eezzz.cn/article/${article.slug}`,
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Article" data={articleSchema} />
      <SEOSchema
        type="WebPage"
        data={{
          name: `${article.title} - 乳色吐息动漫`,
          description: article.excerpt,
        }}
      />

      <Navbar />
      <main className="pt-16">
        <article className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { name: '首页', path: '/' },
                  { name: category?.name || '分类', path: category ? `/category/${category.slug}` : undefined },
                  { name: article.title },
                ]}
              />
            </div>

            <header className="mb-10">
              <div className="flex items-center gap-3 text-xs text-foreground-400 mb-4 flex-wrap">
                {category && (
                  <Link
                    to={`/category/${category.slug}`}
                    className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs hover:bg-secondary-200 transition-colors whitespace-nowrap"
                  >
                    {category.name}
                  </Link>
                )}
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>{article.readTime} 阅读</span>
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-6 leading-tight">
                {article.title}
              </h1>

              <div className="aspect-[2/1] rounded-xl overflow-hidden mb-8">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 乳色吐息动漫`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </header>

            <div className="prose-custom text-foreground-700 leading-relaxed text-sm md:text-base">
              {article.content.split('\n\n').map((paragraph, index) => (
                <p key={index} className="mb-5">
                  {paragraph.trim()}
                </p>
              ))}
            </div>

            <footer className="mt-12 pt-8 border-t border-background-200">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <span className="text-sm text-foreground-500">分享文章：</span>
                  <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-wechat-line"></i>
                  </button>
                  <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-weibo-line"></i>
                  </button>
                  <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-link"></i>
                  </button>
                </div>
                {category && (
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    查看更多{category.name}文章 →
                  </Link>
                )}
              </div>
            </footer>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-14 md:py-20 bg-background-100">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                相关推荐
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {relatedArticles.map((related) => (
                  <Link
                    key={related.slug}
                    to={`/article/${related.slug}`}
                    className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50"
                  >
                    <div className="aspect-[3/2] overflow-hidden">
                      <img
                        src={related.image}
                        alt={related.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                        <span>{related.date}</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                        <span>{related.readTime}</span>
                      </div>
                      <h3 className="text-sm font-heading font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {related.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer newsletterSubmitAddr="https://readdy.ai/api/form/d9st0fllbrt1qcgaj9n0" />
    </>
  );
}